import React, { useState, useEffect, useCallback, useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { getCategories } from "@api/getcategories";
import categoryMap from "@assets/icons/suppliers/category/categoryMap";
import css from './Select.module.scss'
import type { DropDirection } from "react-bootstrap/esm/DropdownContext";
import type { Category } from "@api/getcategories";

interface CategorySearchProps {
  direction?: DropDirection
  currentCategory: Category | null
  setCurrentCategory: React.Dispatch<React.SetStateAction<Category | null>>
}

function CategorySearch({ direction, currentCategory, setCurrentCategory }: CategorySearchProps) {
  const [categories, setCategories] = useState<Category[] | null>(null)
  const popularCategories = [
    'WeddingVenues', 
    'WeddingPhotography', 
    'MarriageCelebrant', 
    'WeddingCars'
  ];

  useEffect(() => {
    if (!categories) {
      getCategories().then(
        result => {
          setCategories(result);
        }
      );
    }
  }, [categories])

  const refButton = useRef<HTMLDivElement>(null);

  const setCategory = useCallback((e: React.MouseEvent, cat: Category) => {
    e.preventDefault();
    setCurrentCategory(cat);
    var refButton2 = refButton.current?.children[0] as HTMLButtonElement;
    refButton2?.click();

  }, [refButton]);

  return <Dropdown className={`category-dropdown ${css.select}`} ref={refButton} drop={direction}>
    <Dropdown.Toggle variant="dropdown" id="ew-search-category">
      <span className={css.dropDownTitle}>{currentCategory ? categoryMap.get(currentCategory?.Slug) : categoryMap.get("WeddingVenues")}{currentCategory ? currentCategory.Name : 'Select Category'}</span>
    </Dropdown.Toggle>
    <Dropdown.Menu className="w-100">
      <Dropdown.Header>POPULAR</Dropdown.Header>
      { popularCategories.map(slug => {
          const category = categories?.find(cat => cat.Slug.toLowerCase() == slug.toLowerCase());
          return !!category && (<a className="dropdown-item" key={`pop-${category.Id}`} href='#' onClick={(e) => setCategory(e, category)}>{category.Name}</a>)
      })}
      <Dropdown.Divider />
      <Dropdown.Header>ALL CATEGORIES</Dropdown.Header>
      {categories?.map((category) => {
        return (<a className="dropdown-item" key={category.Id} href='#' onClick={(e) => setCategory(e, category)}>{category.Name}</a>)
      })}
    </Dropdown.Menu>
  </Dropdown>
}

export default CategorySearch
